import React, { useState, useEffect } from 'react';
import DialogOTP from '../components/Complements/DialogOTP';
import CheckUser from '../components/Users/CheckUser';
import CheckId from '../components/Users/CheckId';
import LoadingScreen from '../components/Complements/LoadingScreen';
import FormQuestionDialogReduxForm from '../components/Questions/FormQuestionDialog';
import { feathersCreateData, feathersFindDataAllDefault } from '../services';
import { encrypt, decrypt } from './../functions/mobile';
import { isEmpty } from '../functions/arrays';
import { history } from '../helpers/history';
import formValidation from "../helpers/formValidation"
import Footer from '../components/Complements/Footer';
import UnlockUser from '../components/Users/UnlockUser';

let dataRefreshToken = null
let timeLifeToken = null
let lengthToken = null
const RecoverContainer = props => {

    const { handleOpenSnack, recoveryType, getDeviceData, devices: deviceReduce } = props;
    // console.log(props)
    const [loading, setLoading] = useState(false);
    const [openDialogOTP, setOpenDialogOTP] = useState(false)
    const [openDialogQuestions, setOpenDialogQuestions] = useState(false)
    const [dataQuestions, setDataQuestions] = useState([])
    const [questionSelected, setQuestionSelected] = useState({})
    const [valueForm, setValueForm] = useState("")
    const [dataUser, setDataUser] = useState("")
    const [positionQuestion, setPositionQuestion] = useState(0)
    const [dataDeviceCurrent, setDataDeviceCurrent] = useState({})
    //const [questionRandom, setquestionRandom] = useState(0)
    const [questionsAnswered, setquestionsAnswered] = useState([])
    const [numberQuestionsAnswered, setNumberQuestionsAnswered] = useState(0)
    const [answer, setAnswer] = useState("")
    const [formErrors, setFormErrors] = useState({})

    //Carga Inicial

    const mount = () => {
        const unmount = () => {
            handleGetDataDevice()
        }

        return unmount()
    }

    useEffect(mount, [recoveryType])

    const handleGetDataDevice = async () => {

        try {

            let resultDevice = {}

            if (isEmpty(deviceReduce)) {
                const deviceInfo = await getDeviceData(null)
                resultDevice = deviceInfo.payload.data
            } else {
                resultDevice = deviceReduce
            }

            //console.log(resultDevice);

            const { ip, device, mac } = resultDevice

            setDataDeviceCurrent({
                ip,
                device,
                mac
            })

        } catch (error) {

        }
    }

    //Formulario Principal

    const handleSubmit = async (valuesForm) => { 
        // console.log('valuesForm', valuesForm)
        if (valuesForm.identifier) { dataRefreshToken = valuesForm }
        try {

            setLoading(true);
            valuesForm = dataRefreshToken
            setquestionsAnswered([])
            setValueForm(valuesForm.identifier.trim())

            let infoDeviceCurrent = {}

            if (dataDeviceCurrent.ip) {
                infoDeviceCurrent = dataDeviceCurrent
            } else {
                let resultDevice = {}

                if (isEmpty(deviceReduce)) {
                    const deviceInfo = await getDeviceData(null)
                    resultDevice = deviceInfo.payload.data
                } else {
                    resultDevice = deviceReduce
                }
                const { ip, device, mac } = resultDevice

                infoDeviceCurrent = {
                    ip,
                    device,
                    mac
                }

                setDataDeviceCurrent(infoDeviceCurrent)
            }
            //console.log('valueform', valueform)
            // console.log('valueform.identifier', valuesForm.identifier)
            let change;
            switch (recoveryType) {
                case 11:
                    change = "contraseña"
                    break;
                case 12:
                    change = "usuario"
                    break;
                case 42:
                    change = "desbloquear"
                    break;
                default:
                    break;
            }
            const sendData = encrypt(JSON.stringify({
                emited: 'NAV',
                type: recoveryType,
                user: valuesForm?.identifier.trim(),
                account: change !== "desbloquear" && valuesForm.account.trim(),
                change: change,
                deviceData: infoDeviceCurrent.device,
                ip: infoDeviceCurrent.ip,
                mac: infoDeviceCurrent.mac
            }))

            const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()

            // console.log('responseGenerateCode', responseGenerateCode)

            const { responseData } = responseGenerateCode;

            const responseGenerateCodeDescrypt = JSON.parse(decrypt(responseData))

            // console.log('responseGenerateCodeDescrypt', responseGenerateCodeDescrypt)
            timeLifeToken = responseGenerateCodeDescrypt.timeLifeToken
            lengthToken = responseGenerateCodeDescrypt.lengthToken
            // console.log(lengthToken)
            const { alert, type } = responseGenerateCodeDescrypt;

            if (type === 'success') {

                setAnswer("")
                setOpenDialogOTP(true);

            } else {

                handleOpenSnack(alert, type)
            }

            setLoading(false)

        } catch (error) {
            // console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al verificar el usuario.", "error");

        }
    }

    //Otp

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false);
    }

    const handleChangeInputOtp = (valueinput) => {
        if (valueinput.target.value.toString().length === lengthToken) {
            receiveOTP({ data: valueinput.target.value.toString() });
        }

    }

    const receiveOTP = async (valuesFormOtp) => {

        try {

            setLoading(true)
            handleCloseDialogOTP()

            const { data } = valuesFormOtp

            const sendData = encrypt(JSON.stringify({
                ip: dataDeviceCurrent.ip,
                mac: dataDeviceCurrent.mac,
                device: dataDeviceCurrent.device,
                type: recoveryType,
                inputOtp: data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            // console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                handleCloseDialogOTP()
                handleConsultQuestions(data)

            } else {

                if (viewDialogOtp === false) {
                    handleCloseDialogOTP()
                } else {
                    setOpenDialogOTP(true)
                }
                setLoading(false)
                handleOpenSnack(message, type);

            }

        } catch (error) {

            // console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido al validar el código.", "error");
        }
    }

    //Questions

    const onCloseDialogQuestion = () => {
        setOpenDialogQuestions(false)
    }

    const handleSubmitQuestion = async () => {

        try {
            //console.log(valuesFormQuestion)
            setLoading(true);

            setOpenDialogQuestions(false)

            let newArrayQuestionsAnswers = questionsAnswered

            if (questionsAnswered.length < (numberQuestionsAnswered - 1)) {

                newArrayQuestionsAnswers.push({
                    idQuestion: questionSelected.id,
                    answerQuestion: answer.toUpperCase()
                })

                setquestionsAnswered(newArrayQuestionsAnswers)

                handleRefreshQuestion()

            } else {

                newArrayQuestionsAnswers.push({
                    idQuestion: questionSelected.id,
                    answerQuestion: answer.toUpperCase()
                })
                let change;
                switch (recoveryType) {
                    case 11:
                        change = "contraseña"
                        break;
                    case 12:
                        change = "usuario"
                        break;
                    case 42:
                        change = "desbloquear"
                        break;
                    default:
                        break;
                }

                let sendData = encrypt(JSON.stringify({
                    ip: dataDeviceCurrent.ip,
                    mac: dataDeviceCurrent.mac,
                    type: 24,
                    device: dataDeviceCurrent.device,
                    questionsAnswer: newArrayQuestionsAnswers,
                    cedule: dataUser,
                    change: change,
                }))

                const responseValidationQuestions = await feathersCreateData("process-validation-user-question", { sendData })()

                const { responseData } = responseValidationQuestions;

                const responseValidationQuestionsDescrypt = JSON.parse(decrypt(responseData))

                //console.log(responseValidationQuestionsDescrypt)

                const { error, message, type } = responseValidationQuestionsDescrypt

                if (error === false) {

                    //setOpenDialogQuestions(viewDialogQuestion)
                    //handleGenerateOtp()
                    history.push('/login')

                }

                handleOpenSnack(message, type)
                setLoading(false)

            }


        } catch (error) {

            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al verificar la respuesta.", "error");
        }
    }

    const handleRefreshQuestion = () => {

        try {

            setLoading(true)

            if (positionQuestion < dataQuestions.length - 1) {

                let newPosition = positionQuestion + 1;

                setQuestionSelected(dataQuestions[newPosition]);
                setPositionQuestion(newPosition);

            } else {

                setQuestionSelected(dataQuestions[0]);
                setPositionQuestion(0);

            }

            setAnswer("")

            setOpenDialogQuestions(true)

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al cargar una nueva pregunta.", "error");
        }
    }

    const handleConsultQuestions = async (inputOtp) => {

        try {

            let query = (recoveryType === 11) ? { username: valueForm } : { identification: valueForm }
            let change;
            switch (recoveryType) {
                case 11:
                    change = "contraseña"
                    break;
                case 12:
                    change = "usuario"
                    break;
                case 42:
                    change = "desbloquear"
                    break;
                default:
                    break;
            }

            let sendData = encrypt(JSON.stringify({
                deviceData: dataDeviceCurrent.device,
                ip: dataDeviceCurrent.ip,
                mac: dataDeviceCurrent.mac,
                type: 24,
                query,
                change: change,
                typeOtp: recoveryType,
                otp: inputOtp
            }))

            const responseQuestions = await feathersFindDataAllDefault("process-user-question", { sendData })()

            //console.log("response : ", responseQuestions)

            const { responseData } = responseQuestions;

            const responseQuestionsDescrypt = JSON.parse(decrypt(responseData))

            const { error, message, type } = responseQuestionsDescrypt

            if (error === false) {

                const { user, questions, parameters } = responseQuestionsDescrypt.data;

                if (questions.length > 0) {

                    let aleatorio = Math.floor(Math.random() * questions.length);

                    aleatorio = (aleatorio < questions.length) ? aleatorio : 0

                    //setquestionRandom(aleatorio)

                    // console.log(aleatorio)
                    setNumberQuestionsAnswered(parseInt(parameters.numberQuestionsAnswers))
                    setPositionQuestion(aleatorio)
                    setDataUser(user.identification)
                    setDataQuestions(questions)
                    setQuestionSelected(questions[aleatorio])
                    setOpenDialogQuestions(true)

                } else {
                    history.push('/login')
                    handleOpenSnack(message, type)
                }

            } else {
                handleOpenSnack(message, type)
            }

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al consultar las preguntas de seguridad.", "error");
        }
    }

    const handleChangeAnswer = (value) => {
        //console.log(value)
        const error = formValidation("text", 1, 50, value) || ""
        setFormErrors({
            answer: error
        })
        setAnswer(value)
    }

    return (
        <div style={{
            //backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
            backgroundSize: "100% 100vh",
            width: "100%",
            height: "100vh",
            minWidth: "100%",
            minHeight: "100vh",
            backgroundRepeat: "no-repeat",
            top: "0"
        }}>
            {
                (recoveryType === 11) ?
                    <CheckUser
                        onSubmit={handleSubmit}
                    /> 
                    : (recoveryType === 12) ?
                    <CheckId
                        onSubmit={handleSubmit}
                    /> 
                    :
                    <UnlockUser onSubmit={handleSubmit} />
            }
            <DialogOTP
                openDialogOTP={openDialogOTP}
                loading={loading}
                initialTime={Date.now()}
                showQR={false}
                onCloseDialogOTP={handleCloseDialogOTP}
                onKeyPress={handleChangeInputOtp}
                OTPSubmit={receiveOTP}
                refreshToken={handleSubmit}
                timeLifeToken={timeLifeToken}

            />
            {(openDialogQuestions === true) && <FormQuestionDialogReduxForm
                questionSelected={questionSelected}
                openDialog={openDialogQuestions}
                onCloseDialogQuestion={onCloseDialogQuestion}
                handleSubmitQuestion={handleSubmitQuestion}
                formErrors={formErrors}
                answer={answer}
                handleChangeAnswer={handleChangeAnswer}
            />}
            <LoadingScreen
                open={loading}
            />
            <Footer />
            {/* <div style={{
                position: 'absolute',
                paddingLeft: '16px',
                paddingRight: '16px',
                left: '0',
                right: '0',
                bottom: '0px',
                marginBottom: '2%',
                color: '#2E2756',
                //textAlign: 'center',
                fontSize: '1.5rem',
                //fontFamily: 'MyriadPro-Regular', 
                //fontWeight: 'medium',
                textAlign: 'center'
                //marginTop: '14%'
            }}>"Haciendo finanzas inclusivas"</div> */}
        </div>
    )
}

export default RecoverContainer
